import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/cookie-policy")({ beforeLoad: redirectTo("/cookies") });
